import {
  getTokenStamped,
  saveToken,
  validateAndGetToken,
} from "../BridgeServices";

export const GenerateTokenBridge = (
  error,
  response,
  context,
  data
) => {
  //1. If there is an error while generating token, handle it gracefully
  if (error) {
    console.log(error);
    return;
  }

  //2. Set the token in the Native data store after stamping it with required info.
  data = typeof data === "string" ? JSON.parse(data) : data;
  var stampedToken = getTokenStamped(
    data.token,
    data.expiresAt,
    data.userId,
    data.name,
    data.language
  );
  saveToken(stampedToken);

  //3. Generate return object from stampedToken
  var validToken = validateAndGetToken(stampedToken);

  //4. Set it in token variable
  window.token = validToken;

  //5. [Optimisation] Call generate token again before the expiry of token so that it is readily available for bot
  //setTimeout(Service.generateToken(), Util.constants.tokenRegenerationTime);
};
